@if (isDisplayed$ | async) {
  <div
    class='gd-ui-section-header  mat-elevation-z2'
    [dir]="dir$ | async">
    <div class="gd-ui-section-header__title tw-flex tw-justify-between tw-items-center tw-gap-2">
      <h2 class="gd-ui-section-header__title-text mat-h2"
        [class.gd-ui-section-header__title-text--no-title]="(title$ | async) !== true">
        {{( title$ | async ) || noTitleLabel}}
        @if (isLive$ | async; as isLive) {
          <span
            i18n
          [class.gd-ui-section-header__live]="isLive">Live now!</span>
        } @else {
          @if (description$ | async) {
            <span> | </span>
          }
        }
        @if (description$ | async; as description) {
          <span>{{description}}</span>
        }
      </h2>
      <div class="gd-ui-section-header__icons tw-flex tw-justify-between tw-items-center tw-gap-3">
        @if (hasUpdates$ | async) {
          <mat-icon
            matTooltip="Unpublished updates available"
            i18n-matTooltip
            class="gd-ui-section-header__updates-available-icon"
            fontSet="fal"
          fontIcon="fa-bell-on"></mat-icon>
        }
        @if (isPublished$ | async) {
          <mat-icon
            matTooltip="Published revision available"
            i18n-matTooltip
            class="gd-ui-section-header__published-icon"
            fontSet="fal"
          fontIcon="fa-globe"></mat-icon>
        }
        @if (sectionInfo$ | async) {
          <gd-section-info
          [sectionInfo$]="sectionInfo$"></gd-section-info>
        }
      </div>
    </div>
  </div>
}
